import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.changeValue = this.changeValue.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(event) {
    event.preventDefault();
    this.setState({'isOpen': true});
  }

  closeModal() {
    this.setState({'isOpen': false});
  }

  changeValue() {
    const {fieldName, fieldValue} = this.props;

    this.props.changePartsFormValue(fieldName, !fieldValue);
    this.updateDisabledPart(fieldName, !fieldValue);
    this.closeModal();
  }

  updateDisabledPart(field, value) {
    if (field !== 'discontinued') {
      return;
    }

    this.props.changePartsFormValue('allowSupplierOrders', !value);
    this.props.changePartsFormValue('allowDealersOrders', !value);
  }

  renderTrigger() {
    const {label, fieldValue} = this.props;

    return (
      <Form.Checkbox toggle label={label} checked={fieldValue} onClick={this.openModal} />
    );
  }

  render() {
    const {label} = this.props;

    return (
      <Modal
        size='tiny'
        className='parts-master'
        open={this.state.isOpen}
        trigger={this.renderTrigger()}
      >
        <Modal.Content>
          ¿Desea modificar el valor del campo <strong>{label}</strong>?
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.closeModal}>Cancelar</Button>
          <Button primary onClick={this.changeValue}>Modificar</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({});

const {changePartsFormValue} = Actions;

export default connect(mapStateToProps, {changePartsFormValue})(ConfirmModal);
